import sanitizeHtml from '@alltrails/core/utils/sanitizeHtml';
import type { PageUICommunityInsightSection } from '../../../utils/PageUI/pageUI';
import styles from './PageUICommunityInsight.module.scss';

// The server wraps matched words in <em>; nothing else is expected or allowed
const sanitizeConfig = { ALLOWED_TAGS: ['em'] };

type Props = {
  section: PageUICommunityInsightSection;
};

/**
 * A review quote, styled to hang off the bottom of its trail's card.
 */
export default function PageUICommunityInsight({ section }: Props) {
  const __html = sanitizeHtml(section.reviewHighlight.textWithHighlighting, sanitizeConfig);

  return <blockquote className={styles.insight} dangerouslySetInnerHTML={{ __html }} />;
}
